import React, { useEffect, useMemo, useState } from "react";
import { t } from "../i18n";
import "./ResetPassword.css";

function parseResetTokens() {
  const hash = window.location.hash ? window.location.hash.substring(1) : "";
  const hashParams = new URLSearchParams(hash);
  const queryParams = new URLSearchParams(window.location.search || "");

  const accessToken = hashParams.get("access_token") || queryParams.get("access_token") || "";
  const refreshToken = hashParams.get("refresh_token") || queryParams.get("refresh_token") || "";
  const tokenHash = hashParams.get("token_hash") || queryParams.get("token_hash") || "";
  const type = hashParams.get("type") || queryParams.get("type") || "";
  const code = hashParams.get("code") || queryParams.get("code") || "";

  return {
    access_token: accessToken,
    refresh_token: refreshToken,
    token_hash: tokenHash,
    type,
    code
  };
}

export default function ResetPassword() {
  const [accessToken, setAccessToken] = useState("");
  const [refreshToken, setRefreshToken] = useState("");
  const [tokenHash, setTokenHash] = useState("");
  const [tokenType, setTokenType] = useState("");
  const [code, setCode] = useState("");
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");

  useEffect(() => {
    const tokens = parseResetTokens();
    setAccessToken(tokens.access_token);
    setRefreshToken(tokens.refresh_token);
    setTokenHash(tokens.token_hash);
    setTokenType(tokens.type);
    setCode(tokens.code);

    if (window.location.hash || window.location.search) {
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, []);

  const canSubmit = useMemo(() => {
    return Boolean(password && passwordConfirm && password === passwordConfirm);
  }, [password, passwordConfirm]);

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus("loading");
    setMessage("");
    const hasSessionTokens = Boolean(accessToken && refreshToken);
    const hasOtpToken = Boolean(tokenHash && tokenType);
    const hasCode = Boolean(code);
    if (!hasSessionTokens && !hasOtpToken && !hasCode) {
      setStatus("error");
      setMessage(t("reset.error.missing"));
      return;
    }
    try {
      const res = await fetch("/api/auth/reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          access_token: accessToken,
          refresh_token: refreshToken,
          token_hash: tokenHash,
          type: tokenType,
          code,
          password
        })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.error || "Erreur");
      setStatus("success");
      setMessage(t("reset.success"));
    } catch (err) {
      setStatus("error");
      setMessage(err.message || t("reset.error.generic"));
    }
  }

  return (
    <div className="reset-page">
      <div className="reset-card">
        <h1 className="reset-title">{t("reset.title")}</h1>
        <p className="reset-subtitle">{t("reset.subtitle")}</p>

        <form className="reset-form" onSubmit={handleSubmit}>
          <label className="reset-field">
            <span>{t("reset.password")}</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
              placeholder={t("reset.password.placeholder")}
            />
          </label>
          <label className="reset-field">
            <span>{t("reset.password.confirm")}</span>
            <input
              type="password"
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
              autoComplete="new-password"
              placeholder={t("reset.password.confirm.placeholder")}
            />
          </label>

          {message && (
            <div className={`reset-alert ${status === "success" ? "success" : "error"}`}>
              {message}
            </div>
          )}

          <button className="reset-btn" disabled={!canSubmit || status === "loading"}>
            {status === "loading" ? "..." : t("reset.submit")}
          </button>
        </form>

        <div className="reset-footer">
          <a href="/decor-landing">{t("reset.back")}</a>
          <span className="reset-sep">·</span>
          <a href="/">{t("reset.back.main")}</a>
        </div>
      </div>
    </div>
  );
}
